export default __webpack_public_path__ + "4658bfada04cd33514dfb3bc51d6db16.glb";